import { render, staticRenderFns } from "./info-preview.vue?vue&type=template&id=daf0640c&scoped=true&"
import script from "./info-preview.vue?vue&type=script&lang=js&"
export * from "./info-preview.vue?vue&type=script&lang=js&"
import style0 from "./info-preview.vue?vue&type=style&index=0&id=daf0640c&scoped=true&lang=css&"
import style1 from "./info-preview.vue?vue&type=style&index=1&id=daf0640c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf0640c",
  null
  
)

export default component.exports